<template>
  <div class="shopTemplate">
    <el-form
      :model="searchForm"
      ref="searchForm"
      :label-position="labelPosition"
      label-width="120"
      inline
      class="custom-formScreen"
    >
      <el-form-item label="选择店铺" prop="sellerId">
        <el-select
          v-model="searchForm.sellerId"
          filterable
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="(item, index) in shopList"
            :key="index + 'value'"
            :label="item.shopName"
            :value="item.sellerId"
            :style="{ color: item.state === 0 ? 'red' : '' }"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开始日期" prop="startTime">
        <el-date-picker
          v-model="searchForm.startTime"
          align="right"
          type="datetime"
          placeholder="选择日期"
          format="yyyy-MM-dd HH:mm:ss"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="结束日期" prop="endTime">
        <el-date-picker
          v-model="searchForm.endTime"
          align="right"
          type="datetime"
          placeholder="选择日期"
          format="yyyy-MM-dd HH:mm:ss"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </el-form-item>
      <el-button type="primary" style="margin-left: 10px" @click="search"
        >搜索</el-button
      >
      <el-button type="primary" @click="reset">重置</el-button>
    </el-form>
    <div class="summary_bag">
      <!-- 符合查询条件的产品共-->
      <div class="summary_pagenum">
        <div class="summary_query">
          符合查询条件的产品共
          <span>{{ tablePagination.total }}</span>
          件
        </div>
      </div>
      <div class="summary_content">
        <div class="summary_batch">
          <span>已选择产品{{ selectRows.length }}件</span>
          <span @click="createTemplate('add')">创建</span>
          <span class="danger" @click="deleteTemplate('batch')">删除</span>
        </div>
        <div class="summary_list">
          <!-- 头部 -->
          <el-table
            ref="tableList"
            :data="tableData"
            style="width: 100%"
            v-loading="tableLoading"
            border
            @selection-change="handleSelectionChange"
            class="pg-table"
            :cell-class-name="'pg-cell'"
            :header-cell-class-name="'pg-header-cell'"
            fit
          >
            <el-table-column
              width="50"
              type="selection"
              align="center"
            ></el-table-column>
            <el-table-column label="店铺" prop="shopName" align="center">
            </el-table-column>
            <el-table-column label="模板名称" prop="stencilName" align="center">
            </el-table-column>
            <el-table-column
              label="更新时间"
              prop="updateTime"
              align="center"
              width="300"
            >
            </el-table-column>
            <el-table-column label="操作" width="200" align="center">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  icon="el-icon-edit"
                  @click="createTemplate('edit', scope.row)"
                  >编辑</el-button
                >
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  @click="deleteTemplate('single', scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-container">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="tablePagination.page"
              :page-sizes="pageSizeList"
              :page-size="tablePagination.size"
              layout="total, sizes,prev, pager, next, jumper"
              :total="tablePagination.total"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>

    <createTemplate
      v-if="createVisible"
      :visible="createVisible"
      :shopList="shopList"
      :pageType="pageType"
      :currentForm="currentForm"
      @cancelVisible="createVisible = false"
      @updateList="getList()"
    ></createTemplate>
  </div>
</template>

<script>
import { ajaxPost, Baseurl } from "@/api/api/api";
import tableMixins from "../../Mixins/tableMixins";
import createTemplate from "./components/createTemplate";
export default {
  name: "shopTemplate",
  mixins: [tableMixins],
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "本月",
            onClick: (picker) => {
              const date = new Date();
              picker.$emit("pick", date);
              this.calculationDate();
            },
          },
          {
            text: "上一月",
            onClick: (picker) => {
              const date = new Date();
              picker.$emit("pick", date);
              this.calculationDate(-1);
            },
          },
          {
            text: "上两月",
            onClick: (picker) => {
              const date = new Date();
              picker.$emit("pick", date);
              this.calculationDate(-2);
            },
          },
          {
            text: "上三月",
            onClick: (picker) => {
              const date = new Date();
              picker.$emit("pick", date);
              this.calculationDate(-3);
            },
          },
        ],
      },
      roleInfo: {}, //角色信息
      sellerType: 11, //平台类型
      labelPosition: "right",
      searchForm: {
        sellerId: undefined,
        startTime: undefined,
        endTime: undefined,
      },
      shopList: [],

      createVisible: false,
      pageType: "add", //add edit
      currentForm: {},
    };
  },
  created() {
    this.roleInfo = JSON.parse(localStorage.getItem("role"));
    this.init();
    this.getList();
  },
  methods: {
    calculationDate(type = 0) {
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      // 计算新的月份和年份，确保处理负数和跨年的情况
      const newYear = year + Math.floor((month + type - 1) / 12);
      const newMonth = ((month + type - 1 + 12) % 12) + 1;
      this.searchForm.startTime = `${newYear}-${newMonth
        .toString()
        .padStart(2, "0")}-01 00:00:00`;

      const prevStamp =
        new Date(year, month + type, day).getTime() - 3600 * 1000 * 24 * day;
      const prevMonth = `${new Date(prevStamp).getFullYear()}-${
        new Date(prevStamp).getMonth() + 1
      }-${new Date(prevStamp).getDate()}`;
      this.searchForm.endTime = `${prevMonth} 23:59:59`;
    },
    init() {
      const API = Baseurl + "roleController/selectNextAndSellerInfoByRid";
      ajaxPost(API, {
        rid: this.roleInfo.rid,
        system: this.roleInfo.system,
        companyId: this.roleInfo.company_id,
        sellerType: this.sellerType,
      }).then((res) => {
        var sellerInfos = res.data.data.next;
        var newArr = [];
        var num = 0;
        for (var i = 0; i < sellerInfos.length; i++) {
          var shop = sellerInfos[i].countryMarks;
          var sellerId = sellerInfos[i].sellerId;
          for (var j = 0; j < shop.length; j++) {
            shop[j].sellerId = sellerId;
            newArr[num] = shop[j];
            num++;
          }
        }
        this.shopList = newArr;
      });
    },

    getList() {
      const sendData = {
        page: this.tablePagination.page,
        size: this.tablePagination.size,
        ...this.searchForm,
      };
      const API = Baseurl + "allegroSeller/selectAllegroSellerStencils";

      this.tableLoading = true;
      ajaxPost(API, sendData)
        .then((res) => {
          this.loadingTable = false;
          const { code, data } = res.data;
          if (code === 200) {
            const { list, total } = data;
            this.tableData = list;
            this.tablePagination.total = total;
          } else {
            this.$message.error("操作失败");
          }
          this.tableLoading = false;
        })
        .catch(() => {
          this.$message.error("操作失败");
          this.tableLoading = false;
        });
    },

    //创建模板
    createTemplate(type, record) {
      this.pageType = type;
      this.currentForm = record || {};
      this.createVisible = true;
    },

    //删除模板
    deleteTemplate(type, record) {
      if (type === "batch") {
        if (this.selectRows && this.selectRows.length === 0) {
          this.$message.warning("请先勾选模板");
          return;
        }
      }
      this.$confirm("此操作将永久删除模板, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.deleteFn(
          type,
          type === "batch" ? this.selectRows?.map((ele) => ele.id) : [record.id]
        );
      });
    },
    deleteFn(type, ids) {
      const sendData = {
        idList: ids,
      };
      const API = Baseurl + "allegroSeller/deleteAllegroSellerStencil";

      ajaxPost(API, sendData)
        .then((res) => {
          this.loadingTable = false;
          const { code, data } = res.data;
          if (code === 200) {
            this.$message.success("删除成功");
            this.clearSelection(); //清空选择
            this.getList();
          } else {
            this.$message.error("操作失败");
          }
        })
        .catch(() => {
          this.$message.error("操作失败");
        });
    },

    reset() {
      this.$refs.searchForm.resetFields();
      this.getList();
    },
    search() {
      this.getList();
    },
  },
  components: { createTemplate },
};
</script>

<style scoped lang="scss">
div.shopTemplate {
  padding-bottom: 72px;
  .summary_pagenum {
    width: 100%;
    margin-bottom: 10px;
    overflow: hidden;
    background: #f5f5f5;
    .summary_query {
      width: 20%;
      float: left;
      padding: 0 10px;
      line-height: 32px;
      letter-spacing: 1px;
      color: #585858;
      span {
        color: #2c8dff;
      }
    }
    .block {
      float: right;
    }
  }
  .summary_content {
    width: 100%;
    border: 1px solid #eee;
    overflow: hidden;
    .summary_batch {
      width: 100%;
      overflow: hidden;
      border-bottom: 1px solid #eee;
      span {
        display: block;
        float: left;
        line-height: 20px;
        margin: 10px 0px;
        padding: 0 20px;
        color: #2c8dff;
        overflow: hidden;
        border-left: 1px #2c8dff solid;
        cursor: pointer;

        &.danger {
          color: #f56c6c;
        }
      }
      span:nth-child(1) {
        color: #000;
        border-left: 0px;
      }
    }
  }

  .pagination-container {
    width: 1789px;
    padding: 20px;
    position: fixed;
    right: 0;
    bottom: 0;
    background: #fff;
    z-index: 999;

    .el-pagination {
      display: flex;
      justify-content: center;
    }
  }
}
</style>
